import * as classNames from 'classnames';
import * as React from 'react';

import * as Bulma from './../../bulma';
import { withHelpersModifiers } from './../../bulma';

export interface NavCenter<T> extends Bulma.Tag, React.HTMLProps<T> { }

export function NavCenter({ tag = 'div', ...props }: NavCenter<HTMLElement>) {
    const className = classNames('nav-center', props.className);

    return React.createElement(tag, { ...props, className });
}

const HOC = /*@__PURE__*/withHelpersModifiers(NavCenter);
export default HOC;



// WEBPACK FOOTER //
// ./src/components/Nav/NavCenter.tsx